<!--
  LoginDialog.vue
  Wrapper del LoginForm para ser invocado desde cualquier vista (ej. Checkout.vue)
  sin perder el flujo del usuario. Tras un login exitoso emite "logged-in" y
  deja al consumidor decidir si redirige (ej. a /member/eventCheckout/:eventId),
  recarga precios, etc.
-->
<template>
  <v-dialog
    :value="value"
    :max-width="520"
    scrollable
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-text class="pa-0">
        <LoginForm
          mode="dialog"
          :event-id="eventId"
          :redirect="redirect"
          @logged-in="onLoggedIn"
          @close="$emit('input', false)"
          @recover-password="onRecoverPassword"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import LoginForm from "@/components/shared/LoginForm.vue";

export default {
  name: "LoginDialog",
  components: {
    LoginForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    eventId: {
      type: String,
      default: null,
    },
    redirect: {
      type: String,
      default: null,
    },
  },
  methods: {
    onLoggedIn(response) {
      this.$emit("logged-in", response);
      this.$emit("input", false);
    },
    onRecoverPassword() {
      this.$emit("recover-password");
    },
  },
};
</script>
